import { LH_FALLBACK_NUMBER, LH_MX_FALLBACK_NUMBER } from '@/config/whatsappListingNumbers'

export interface whatsappNumbers {
  mx: string
  co: string
}

export default defineNuxtPlugin(({ $config }) => {
  const whatsappNumbers: whatsappNumbers = {
    // co: $config.public.whatsappNumberCo as string,
    // mx: $config.public.whatsappNumberMx as string,
    co: LH_FALLBACK_NUMBER,
    mx: LH_MX_FALLBACK_NUMBER
  }

  const whatsappBotNumbers: whatsappNumbers = {
    co: $config.public.whatsappBotNumberCo as string,
    mx: $config.public.whatsappBotNumberMx as string
  }

  return {
    provide: {
      whatsappNumbers,
      whatsappBotNumbers
    }
  }
})
